import { makeAutoObservable } from "mobx";
import { SearchObject } from "app/common/Model/SearchObject";
import {
  pagingRoomAndService,
  getRoomAndServiceById,
  saveRoomAndService,
  markDeleteRoomAndService,
  importExcelRoomAndService,
  downloadTemplate
} from "app/services/RoomAndService";
import { Country } from "app/common/Model/Country";
import { checkSearchObject } from "app/common/LocalFunction";
import { toast } from "react-toastify";

const isDefaultSelected = {
  isDefault: true,
};
export default class RoomAndServiceStore {
  listAllRoomAndService = [];
  searchRoomAndService = new SearchObject();
  pageRoomAndService = null;
  selectedRoomAndService = { ...isDefaultSelected };
  openFormCreateOrEdit = false;
  openFormUploadFile = false;
  openConfirmDeleteRoomAndService = false;
  constructor() {
    makeAutoObservable(this);
  }

  pagingRoomAndService = () => {
    const { room, department, service, ...ortherData } =
      this.searchRoomAndService;
    if (room) {
      ortherData.roomId = room.id;
    }
    if (department) {
      ortherData.departmentId = department.id;
    }
    if (service) {
      ortherData.serviceId = service.id;
    }
    pagingRoomAndService(ortherData)
      .then(({ data }) => {
        this.pageRoomAndService = data;
      ;
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu có lỗi");
      });
  };

  handleChangeFormSearch = (searchRoomAndService) => {
    this.searchRoomAndService = checkSearchObject(
      this.searchRoomAndService,
      searchRoomAndService
    );
    this.pagingRoomAndService();
  };

  handleOpenFormCreateOrEdit = (productMappingId) => {
    if (Boolean(productMappingId)) {
      getRoomAndServiceById(productMappingId)
        .then(({ data }) => {
          let newData = {
            ...data,
            drug:
              data?.productType === 1
                ? {
                    id: data?.emrProductId,
                    name: data?.name,
                  }
                : null,
            medicalSupply:
              data?.productType === 2
                ? {
                    id: data?.emrProductId,
                    name: data?.name,
                  }
                : null,
            unit:
              data?.productType === 3
                ? {
                    id: data?.emrProductId,
                    name: data?.name,
                  }
                : null,
            department:
              data?.productType === 4
                ? {
                    id: data?.emrProductId,
                    name: data?.name,
                  }
                : null,
          };
          this.selectedRoomAndService = newData;
          this.openFormCreateOrEdit = true;
        })
        .catch((error) => {
          console.error(error);
          toast.error("Lấy dữ liệu có lỗi");
        });
    } else {
      this.selectedRoomAndService = new Country();
      this.openFormCreateOrEdit = true;
    }
  };

  saveRoomAndService = (productMapping, { setSubmitting }) => {
    return saveRoomAndService({
      ...productMapping,
      emrProductId:
        productMapping?.drug?.id ||
        productMapping?.medicalSupply?.id ||
        productMapping?.unit?.id ||
        productMapping?.department?.id ||
        null,
    })
      .then(() => {
        this.selectedRoomAndService = null;
        toast.success("Lưu thành công!");
        this.handleClosePopup();
        this.pagingRoomAndService();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lưu thông tin có lỗi");
      })
      .finally(() => setSubmitting(false));
  };

  handleDeleteProductMapping = (productMapping) => {
    this.selectedRoomAndService = { id: productMapping?.id };
    this.openConfirmDeleteRoomAndService = true;
  };

  handleConfirmDeleteProductMapping = () =>
    markDeleteRoomAndService(this?.selectedRoomAndService?.id)
      .then(() => {
        if (
          this.searchRoomAndService.pageIndex > 1 &&
          this.pageRoomAndService.content.length === 1
        ) {
          this.searchRoomAndService.pageIndex -= 1;
        }
        toast.success("Xóa hàng hóa thành công!");
        this.handleClosePopup();
        this.pagingRoomAndService();
      })
      .catch((err) => {
        console.error(err);
        toast.error("Xóa hàng hóa có lỗi");
      });

  handleClosePopup = () => {
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteRoomAndService = false;
    this.openFormUploadFile = false;
  };

  resetStore = () => {
    this.searchRoomAndService = new SearchObject();
    this.pageRoomAndService = null;
    this.selectedRoomAndService = { ...isDefaultSelected };
    this.openFormCreateOrEdit = false;
    this.openConfirmDeleteRoomAndService = false;
  };
  handleUploadFile = () => {
    this.openFormUploadFile = true;
  };
  handleImportExcel = (file) => {
    importExcelRoomAndService(file)
      .then(({ data }) => {
        toast.success("Tải file thành công!");
        this.handleClosePopup();
      })
      .catch((error) => {
        console.error(error);
        toast.error("Lấy dữ liệu có lỗi");
      });
  };
   handleDownloadTemplate = async () => {
          try {
              const res = await downloadTemplate();
              const url = window.URL.createObjectURL(res?.data);
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", "MAU_NHAP_DANH_MUC_PHONG_VA_DICH_VU" + ".xlsx");
              document.body.appendChild(link);
              link.click();
          } catch (error) {
              console.log(error);
          }
      };
}
